import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { AppRoutes } from './pages';
import { ThemeProvider } from './hooks';
import { CookieConsentProvider } from './components/CookieConsentProvider';
import './locale'; // Init locale
import 'vanilla-cookieconsent/dist/cookieconsent.css';

export function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <CssBaseline />
        <AppRoutes />
        <CookieConsentProvider />
      </BrowserRouter>
    </ThemeProvider>
  );
}
